import React from 'react';
import { Section } from './Shared';
export const CostComparison = () => {
  const costs = [{
    without: 'Prescribir sin ficha técnica validada',
    cost: 'Inseguridad clínica que el paciente percibe'
  }, {
    without: 'Sin semáforo de seguridad por planta',
    cost: 'Riesgo real de indicar algo contraindicado'
  }, {
    without: 'Sin tabla de interacciones',
    cost: 'Paciente medicado en riesgo sin saberlo'
  }, {
    without: 'Sin protocolo por sistema',
    cost: 'Armás cada sesión desde cero, sin estructura'
  }, {
    without: 'Sin recetario de fórmulas',
    cost: 'Combinaciones improvisadas sin respaldo'
  }, {
    without: 'Sin dosificación pediátrica',
    cost: 'No sabés cómo ajustar para niños o adultos mayores'
  }, {
    without: 'Sin criterios de derivación',
    cost: 'No sabés cuándo la fitoterapia no alcanza'
  }, {
    without: 'Sin ficha de consultorio',
    cost: 'Cada consulta sin registro ni continuidad real'
  }, {
    without: 'Sin guía de proveedores',
    cost: 'Materia prima de calidad desconocida'
  }, {
    without: 'Sin el sistema',
    cost: 'El mismo ciclo de incertidumbre, la próxima semana'
  }];
  return <Section data-id="element-17">
      <div className="text-center mb-12" data-id="element-18">
        <h2 className="md:text-4xl font-display font-bold mb-4 flex items-center justify-center text-[24px] text-brand-purpleDark" data-id="element-19">
          <span className="mr-3" data-id="element-20">⚖️</span> ¿CUÁNTO CUESTA NO TENERLO?
        </h2>
      </div>

      <div className="max-w-4xl mx-auto" data-id="element-21">
        <div className="hidden md:block" data-id="element-22">
          <div className="grid grid-cols-2 gap-4 mb-4 px-4" data-id="element-23">
            <div className="font-serif font-bold text-lg text-brand-purple" data-id="element-24">
              Sin Kit Saberes Ancestrales
            </div>
            <div className="font-serif font-bold text-lg text-brand-burgundy" data-id="element-25">
              Costo real
            </div>
          </div>
          <div className="space-y-3" data-id="element-26">
            {costs.map((row, i) => <div key={i} className="grid grid-cols-2 gap-4 glass-panel p-5 rounded-xl items-center border-brand-burgundy/10 bg-white/70" data-id="element-27">
                <div className="text-sm font-medium text-brand-text pr-4" data-id="element-28">
                  {row.without}
                </div>
                <div className="text-sm text-brand-burgundy/90 font-medium" data-id="element-29">
                  {row.cost}
                </div>
              </div>)}
          </div>
        </div>

        <div className="md:hidden space-y-4" data-id="element-30">
          {costs.map((row, i) => <div key={i} className="glass-panel p-4 rounded-xl border-brand-burgundy/10 bg-white/70 space-y-2" data-id="element-31">
              <p className="text-sm font-medium text-brand-text" data-id="element-32">
                {row.without}
              </p>
              <div className="flex items-start space-x-2 text-brand-burgundy/90 font-medium" data-id="element-33">
                <span className="text-brand-burgundy shrink-0" data-id="element-34">→</span>
                <span className="text-sm" data-id="element-35">{row.cost}</span>
              </div>
            </div>)}
        </div>
      </div>

      <div className="text-center mt-16" data-id="element-36">
        <p className="text-xl md:text-2xl font-display italic font-[600] text-brand-purpleDark" data-id="element-37">
          "El terapeuta que tiene un sistema, aplica con confianza. El que
          aplica con confianza, genera resultados. El que genera resultados,
          crece." 🌿
        </p>
      </div>
    </Section>;
};